/**
 * `appointmentType` do Appointment marcado pela tela de Teleconsultoria
 * (afiliada consumindo horário da prestadora). Mesmo padrão de
 * "prontoatendimento" e "EVOLUTION": code próprio no v2-0276.
 */
export const TELECONSULTORIA_APPOINTMENT_TYPE = "TELECONSULTORIA";
export const TELECONSULTORIA_APPOINTMENT_TYPE_TEXT = "Teleconsultoria";

/** Duração do atendimento "Agora" (sem horário marcado). */
export const TELECONSULTORIA_NOW_DURATION_IN_MINUTES = 30;

/**
 * Reference de paciente nos dois formatos usados no sistema:
 * `Patient/<id>` e `Patient?identifier=urn:oid:...|<cpf>` (gravado pelo AuxiliarData).
 */
export function isPatientReference(reference: string | undefined): boolean {
  return Boolean(reference && /^Patient[/?]/.test(reference));
}

/** Participant paciente do Appointment (qualquer formato de reference). */
export function patientParticipantActor(
  appointment: fhir5.Appointment | undefined,
): fhir5.Reference | undefined {
  return appointment?.participant?.find((item) => isPatientReference(item.actor?.reference))
    ?.actor;
}

/**
 * Location do Appointment (participant `Location/<id>`).
 * O scheduling exige o filtro de Location para devolver o Appointment.
 */
export function locationParticipantActor(
  appointment: fhir5.Appointment | undefined,
): fhir5.Reference | undefined {
  return appointment?.participant?.find((item) =>
    item.actor?.reference?.startsWith("Location/"),
  )?.actor;
}

/** Appointment criado pela tela de Teleconsultoria (code TELECONSULTORIA). */
export function isTeleconsultoriaAppointment(
  appointment: fhir5.Appointment | undefined,
): boolean {
  return Boolean(
    appointment?.appointmentType?.coding?.some(
      (coding) => coding.code === TELECONSULTORIA_APPOINTMENT_TYPE,
    ),
  );
}
